'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useState, useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation'

// lib files
import shouldRenderContentNav from "@/lib/helpers/content-nav";
import { StationData } from "@/lib/types/api/stations-data";

// components
import ContentNav from '@/components/Navigation/ContentNav';
import UtilityNav from '@/components/Navigation/UtilityNav';

// styles
import styles from '@/components/Navigation/Navigation.module.scss';

interface NavigationProps {
  depRenderContentNav?: boolean;
  isAccessibilityExploreHubEnabled: boolean;
  isPBSPatrioticLogoEnabled?: boolean;
  isSVP: boolean;
  isUSorTerritories: boolean;
  stationData?: StationData;
}

const Navigation = (props: NavigationProps) => {
  const {
    depRenderContentNav,
    isAccessibilityExploreHubEnabled,
    isPBSPatrioticLogoEnabled = false,
    isSVP,
    isUSorTerritories,
    stationData,
  } = props;

  const previousScrollY = useRef(0);

  const [scrollDirectionState, setScrollDirectionState] = useState<'up' | 'down'>('down')
  const [atTop, setAtTop] = useState(true)
  const pathname = usePathname()
  const renderContentNav = depRenderContentNav !== undefined ? depRenderContentNav : shouldRenderContentNav(pathname)

  useEffect(() => {
    let frame = 0;

    const handleScroll = () => {
      const latest = window.scrollY;
      if (latest < 0) return;

      const scrollDirection = latest > previousScrollY.current ? 'down' : 'up';

      setScrollDirectionState(scrollDirection);
      setAtTop(latest < 5);

      previousScrollY.current = latest;
    };

    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        handleScroll();
      });
    };

    handleScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header className={styles.navigation} data-sentry-component="Navigation" data-sentry-source-file="Navigation.tsx">
      <UtilityNav
        stationData={stationData}
        isSVP={isSVP}
        isUSorTerritories={isUSorTerritories}
        atTop={atTop}
        isPBSPatrioticLogoEnabled={isPBSPatrioticLogoEnabled}
        isAccessibilityExploreHubEnabled={isAccessibilityExploreHubEnabled}
      data-sentry-element="UtilityNav" data-sentry-source-file="Navigation.tsx" />
      {renderContentNav && (
        <ContentNav
          isSVP={isSVP}
          atTop={atTop}
          scrollDirection={scrollDirectionState}
          isLocalized={!!(stationData?.id)}
          isPassportEnabled={!!stationData?.attributes.passport_enabled}
          isAccessibilityExploreHubEnabled={isAccessibilityExploreHubEnabled}
        />
      )}
    </header>
  );
}

export default Navigation;
